export default "__VITE_ASSET__CGNaFBVA__"